import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IIntroductionsDetail, IIntroductionsSearchFields, introductionsService, IIntroductionsFormFields, IIntroductionsInsert, IIntroductionsUpdate } from "./introductionsService";
import { transPgToPagination } from "@/model/globalModel";
import { globalPrompt } from "@/components/message";
import { ISearchPage } from "@/types/AppTypes";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM, defaultMdCmParam } from "@/utils/constants";

interface IIntroductionsDrawerType {
    visible: boolean,
    mode: "add" | "edit" | "look"
}

export const useIntroductionsModel = createModel(function () {
    //列表数据源
    const [dataSource, setDataSource] = useState<IIntroductionsDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<IIntroductionsSearchFields>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);

    //列表查询
    const loadData = async (page?: ISearchPage, searchValue: IIntroductionsSearchFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            sourceApp: defaultMdCmParam.sourceApp,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: page?.pageNum ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await introductionsService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IIntroductionsSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }

    /**
     * 详情
     */
    const initIntroductionsDrawer: IIntroductionsDrawerType = { visible: false, mode: "add" }
    const [introductionsDrawer, setIntroductionsDrawer] = useState<IIntroductionsDrawerType>(initIntroductionsDrawer);
    const setIIntroductionsDrawer = (str?: "add" | "edit" | "look") => setIntroductionsDrawer(str ? { visible: true, mode: str } : initIntroductionsDrawer);

    //根据id查询
    const getSelectedRowData = () => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        return filters && filters.length > 0 ? { ...filters[0] } : {};
    };

    const insertIntroductions = async (val: IIntroductionsInsert) => {
        let { retData } = await introductionsService.insert(val);
        if (retData) {
            loadData();
            setIIntroductionsDrawer();
            globalPrompt("message", { text: "新增成功", type: "success" })
        } else {
            globalPrompt("message", { text: "新增失败", type: "error" });
        }
    }

    //表单编辑 Api
    const editIntroductions = async (val: IIntroductionsInsert) => {
        let { retData } = await introductionsService.update({ ...val, id: selectedRowKeys[0] });
        if (retData) {
            loadData();
            setIIntroductionsDrawer();
            globalPrompt("message", { text: "修改成功", type: "success" })
        } else {
            globalPrompt("message", { text: "修改失败", type: "error" });
        }
    }

    //启用 禁用 api
    const disableIntroductions = async (id: string) => {
        let { retData } = await introductionsService.disable(id);
        loadData();
        globalPrompt("message", { text: "操作成功", type: "success" })
    };

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        /***method***/
        introductionsDrawer, setIIntroductionsDrawer,
        getSelectedRowData,
        insertIntroductions,
        editIntroductions,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        disableIntroductions,
    }
});